import { useCallback } from 'react';

import {
  shareOnLinkedIn,
  shareOnFacebook,
  shareOnTwitter,
  shareOnEmail,
  getPageName,
} from '../../../../utils/widgets/shareWidget';

import useStyles from './styles';
import { IShareMethodButton } from './types';

function ShareMethodButton({
  backgroundColor,
  icon,
  toolUrl,
  value,
  analytics,
  setShowShareModal,
  setShowCopyInfoAlert,
}: IShareMethodButton) {
  const classes = useStyles({ backgroundColor, icon });
  const { component: Icon } = icon;

  const handleOnClick = useCallback(() => {
    const pageName = getPageName();
    analytics.sharePage(value, pageName);
    setShowCopyInfoAlert(false);
    switch (value) {
      case 'embed':
        setShowShareModal(false);
        break;
      case 'facebook':
        shareOnFacebook(toolUrl);
        break;
      case 'linkedin':
        shareOnLinkedIn(toolUrl);
        break;
      case 'twitter':
        shareOnTwitter(toolUrl);
        break;
      case 'copy_link':
        navigator.clipboard.writeText(toolUrl);
        setShowCopyInfoAlert(true);
        break;
      case 'mail':
        shareOnEmail(toolUrl);
        break;
    }
  }, [setShowCopyInfoAlert, setShowShareModal, toolUrl, value]);

  return (
    <button className={classes.root} onClick={handleOnClick}>
      <Icon className={classes.icon} />
    </button>
  );
}
export default ShareMethodButton;
